module.exports = __webpack_public_path__ + "img/nopay2.3c9c7862.png";